import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';

import { UitkSpacing, UitkSpacingProps } from 'uitk-react-spacing';

export interface BodyRegionProps {
  templateContent: React.ReactElement<unknown>;
  pageHeader?: string;
}
export class BodyRegion extends React.Component<BodyRegionProps> {
  public render() {
    const { pageHeader, templateContent } = this.props;

    const header = pageHeader && (
      <header>
        <h1 className="is-visually-hidden">{pageHeader}</h1>
      </header>
    );

    const mainRegion = (
      <div>
        {header}
        <div className="main-region">
          <ErrorBoundary label="hotel.masterPage.template">{templateContent}</ErrorBoundary>
        </div>
      </div>
    );

    const controlStyling: UitkSpacingProps = {
      margin: { medium: { inline: 'six' } },
    };
    const variantOneStyling: UitkSpacingProps = {
      margin: { medium: { inline: 'twelve' } },
      padding: { medium: { inline: 'twelve' } },
    };

    return (
      <Experiment name="lodging_reconnect_travel_hackathon">
        <ExperimentControl>
          <UitkSpacing {...controlStyling}>{mainRegion}</UitkSpacing>
        </ExperimentControl>
        <ExperimentVariant bucket={1}>
          <UitkSpacing {...variantOneStyling}>{mainRegion}</UitkSpacing>
        </ExperimentVariant>
      </Experiment>
    );
  }
}
